import { Result, ResultVariants } from '@dexma/ui-components';
import { StyledTable } from 'adapter/in/common/components/HomeTable/style';
import Bot from 'asset/images/bot.svg';
import i18n from 'asset/translation';
import React, { memo, ReactElement, useState } from 'react';

export type HomeTableProps = {
    columns: any | null;
    dataSource: any[] | null;
    isLoading: boolean;
    showError: boolean;
    onChange: (
        pagination: never,
        filters: never,
        sorter: { column: { columnKey: string }; order: 'ascend' | 'descend' },
        extra: { currentDataSource: []; action: 'paginate' | 'sort' | 'filter' }
    ) => void;
    onRow?: (record: any) => React.HTMLAttributes<HTMLElement> & React.TdHTMLAttributes<HTMLElement>;
};

const HomeTable = (props: HomeTableProps): ReactElement => {
    const { columns, dataSource, isLoading, showError, onChange, onRow } = props;
    const [currentPage, setCurrentPage] = useState(1);

    const onPageChange = (page: number) => setCurrentPage(page);

    const dataSourcePaginated = () => {
        const startIndex = (currentPage - 1) * 10;
        return dataSource?.slice(startIndex, startIndex + 10)?.map((source) => ({ ...source, key: source.id }));
    };

    return (
        <StyledTable
            columns={columns}
            dataSource={dataSourcePaginated()}
            isLoading={isLoading}
            showError={showError}
            onRow={onRow}
            locale={{
                triggerAsc: i18n.t('dashboards.sort.ascend', { column: i18n.t('common.name') }),
                triggerDesc: i18n.t('dashboards.sort.descend', { column: i18n.t('common.name') }),
            }}
            errorContent={
                <Result
                    variant={ResultVariants.DEFAULT}
                    title={i18n.t('common.errorWrong')}
                    info={i18n.t('common.errorWrongInfo')}
                    iconElement={<Bot />}
                />
            }
            onChange={onChange as any}
            currentPage={currentPage}
            totalRegisters={dataSource ? dataSource.length : 0}
            pageSize={10}
            onPageChange={onPageChange}
            prevPageAriaLabel={i18n.t('common.ariaLabel.tablePagination.prevPage')}
            prevDotsPageAriaLabel={i18n.t('common.ariaLabel.tablePagination.prevDotsPage')}
            nextDotsPageAriaLabel={i18n.t('common.ariaLabel.tablePagination.nextDotsPage')}
            nextPageAriaLabel={i18n.t('common.ariaLabel.tablePagination.nextPage')}
        />
    );
};

export default memo(HomeTable);
